export default __webpack_public_path__ + "static/media/dion-beetson-oF7hh97lVqA-unsplash.daf2fea8.jpg";